import { buildStandardReport } from './standardReport.mjs';

// Independent A4 report template. The original Timesheet PDF remains untouched.
const ascii=value=>String(value??'').replace(/[^\x20-\x7E]/g,' ');
export async function createStandardReportPdf(assessment,answers,contact) {
  const report=buildStandardReport(assessment,answers);
  const {jsPDF}=await import('jspdf');
  const doc=new jsPDF({unit:'mm',format:'a4',compress:true});
  const margin=17,width=176,bottom=273;
  let y=0,page=0;
  const write=(text,x,at,size=9,bold=false)=>{
    doc.setFont('helvetica',bold?'bold':'normal');
    doc.setFontSize(size);doc.setTextColor(35,43,66);
    const lines=doc.splitTextToSize(ascii(text),width-(x-margin));
    doc.text(lines,x,at);
    return at+Math.max(1,lines.length)*size*.41+3;
  };
  const pageHeader=()=>{
    if(page++) doc.addPage();
    doc.setFillColor(21,29,54);doc.rect(0,0,210,32,'F');
    doc.setTextColor(255,255,255);doc.setFont('helvetica','bold');doc.setFontSize(14);
    doc.text('BPA Solutions',margin,15);
    doc.setFontSize(8);doc.text('Personalised business assessment',margin,22);
    y=44;
  };
  const next=(needed=16)=>{if(y+needed>bottom)pageHeader();};
  const paragraph=(text,size=9,bold=false)=>{
    doc.setFont('helvetica',bold?'bold':'normal');doc.setFontSize(size);
    const lines=doc.splitTextToSize(ascii(text),width);
    next(lines.length*size*.41+6);
    y=write(text,margin,y,size,bold);
  };
  pageHeader();
  paragraph(assessment.title,17,true);
  paragraph('Prepared for '+contact.firstName+' | '+contact.businessName,10);
  y+=3;
  paragraph('Overall health score: '+report.score+'/100  |  '+report.band,12,true);
  paragraph('Lead qualification and opportunities are indicative, based on your answers.');
  y+=5;
  paragraph('Operational findings',12,true);
  for(const area of report.dimensions){
    next(28);
    paragraph(area.label+'  ('+area.score+'/'+area.maxPoints+')',10,true);
    paragraph(area.finding);
  }
  y+=4;next(20);paragraph('Priority improvements',12,true);
  for(const risk of report.risks){
    paragraph(risk.label,10,true);
    paragraph(risk.recommendation);
  }
  y+=4;next(20);paragraph('Recommended next step',12,true);
  paragraph(report.nextStep);
  next(14);
  paragraph('Indicative assessment only. This is not legal, financial or professional advice.',7);
  for(let p=1;p<=doc.getNumberOfPages();p++){
    doc.setPage(p);doc.setDrawColor(220,224,230);doc.line(margin,282,193,282);
    doc.setFontSize(7);doc.setTextColor(110,115,130);doc.text('BPA Solutions  |  '+assessment.title,margin,287);
    doc.text(p+' / '+doc.getNumberOfPages(),183,287);
  }
  return doc;
}
export async function createStandardReportAttachment(assessment,answers,contact){
  const pdf=await createStandardReportPdf(assessment,answers,contact);
  return {filename:'BPA-'+assessment.id+'-Report.pdf',content:pdf.output('datauristring').split(',')[1],
    content_type:'application/pdf'};
}
export async function downloadStandardReport(assessment,answers,contact){
  const pdf=await createStandardReportPdf(assessment,answers,contact);
  pdf.save('BPA-'+assessment.id+'-Report.pdf');
}